<template>
    <div>
<!--
        
        <p-button @click="onSaveUserParameters()" outline class="hover-text min float-right"><i class="fa fa-check"></i><span>{{ $t('button.save') }}</span></p-button>                         

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />

        <b-table 
            :items="userParameters" 
            :fields="fields">

            <template v-slot:cell(value)="{ item, field: { key } }">
                <b-form-group v-if="item.name === 'PRIMARY_LANGUAGE'">
                <languageSelect v-model="item.value" id="language"/>
                </b-form-group>
                <b-form-group v-else>
                    <div class="w-50">
                        <input type="text" class="form-control" v-model="item[key]">
                    </div>
                </b-form-group>
            </template>

        </b-table>
        -->

        <div v-for="item in userParameters" :key="item.id"> 
            <div><label>{{ $t(item.description) }}</label></div>
            <b-row>
                <b-col cols='5' style='font-size: 14px'>{{ $t(item.defaultValue) }}</b-col>
                <b-col> 
                    <languageSelect v-if="item.name === 'PRIMARY_LANGUAGE'" v-model="item.value" id="language"/>
                    <input v-else type="text" class="form-control" v-model="item.value">
                </b-col>
            </b-row>
            <hr>
        </div>

        <p-button @click="onSaveUserParameters()" type="success" size="sm" outline :disabled="loading"><i class="fa fa-check"></i><span>{{ $t('button.save') }}</span></p-button>                         

        <RequestInfo type="save" :ok="ok" :error="error" :loader="loading" />
    
    </div>
</template>

<script>

import languageSelect from '@/components/System/LanguageSelect'

export default {
        components: { languageSelect },
        props: ['item'],
        data() {
            return {
                fields: [
                { key: "description", label: "",
                    formatter: (value, key, item) => {
                    return this.$t(item.description);
                    }
                },
                { key: "defaultValue", label: "" },
                { key: "value", label: "" },
                ],
                userParameters: [],
                ok: false,
                error: false,
                loading: false,
                infoType: "save"
            }
    },
    created() {
        this.getUserParameters(this.item.id);
    },
    watch: {
        item: function(item) {
            this.getUserParameters(item.id);
            this.ok = this.error = this.loading = false;  
        },
    }, 
    methods: {
        getUserParameters(item) {
            this.$store.dispatch('userDataHandler/getUsersGroups' , item ).then( response => {
                this.userParameters = response.data.parameters;
            });                
       },
       onSaveUserParameters() {
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
            setTimeout(() => { 
                // console.log("request")
                this.$store.dispatch('userDataHandler/saveUserParameters' , this.userParameters, this.item.id).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;

                    //console.log("done")
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    //this.$emit('updateItem', this.item);
                })
            }, 1000);
        }
    }
}
</script>
